import { Component, Input, OnInit, OnDestroy, OnChanges, Output, EventEmitter } from '@angular/core';
import { WeGoConfig } from '../../shared/config';

@Component({
  selector: 'wego-search-list',
  template: `
  <form (ngSubmit)="OnSearch()" class="form-inline mar_bot_10">
    <div class="form-group">
      <div class="input-group">
        <input type="text" class="form-control" [(ngModel)]="searchTerm" name="searchTerm" autocomplete="off" maxlength="100">
          <div class="input-group-btn">
            <button class="btn btn-default search-icon" type="submit">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    <div class="form-group">
      <button class="btn btn-default reset-icon" type="button" (click)="OnReset($event)">
        <i class="fa fa-eraser" aria-hidden="true"></i>
      </button>
    </div>
    <div *ngIf="isExported" class="form-group">
      <button class="btn btn-default export-icon" type="button" (click)="OnExport($event)" title="{{'LblExportAll(CSV)' | translate}}">
        <i class="fa fa-download" aria-hidden="true"></i>
      </button>
    </div>
    <div *ngIf="isDeleted" class="form-group">
      <button [disabled]="!isDeleteEnabled" class="btn btn-default delete-icon" type="button" (click)="OnDeleteAll($event)" title="{{'LblDeleteAllSelectedRecords' | translate}}">
        <i class="fa fa-trash-o" aria-hidden="true"></i>
      </button>
    </div>
      <div *ngIf="isCancel" class="form-group">
      <button [disabled]="!isCancelEnabled" class="btn btn-default cancel-icon" type="button" (click)="OnCancelAll($event)" title="{{'LblCancelAllSelectedRecords' | translate}}">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>
     <div *ngIf="isCustomButton" class="form-group">
      <button [disabled]="!isCustomButtonEnabled" class="btn btn-default add-icon" type="button" (click)="OnCustomeButton($event)" [attr.title]="title">
        <i [ngClass]="customIcon" aria-hidden="true"></i>
      </button>
    </div>
    <div class="form-group pull-right">
      <select class="form-control" title='Items Per Page'  [(ngModel)]="itemPerPage"  name="itemPerPage" (change)="OnPagingChange($event.target.value)">
         <option *ngFor="let item of itemPerPageList"  [attr.value]='item.value' >{{ item }}</option>
      </select>
    </div>
  </form>
  `,
  styles: [
    `
    .search-icon {
        color:#2ba2aa;
    }
    .reset-icon {
        color:#DD9933;
    }
    .export-icon {
        color:#01A2D9;
    }
    .delete-icon {
        color:#f00;
    }
    .cancel-icon {
        color:#f00;
    }
    .add-icon {
        color:#080;
    }
    `
  ]
})

export class SearchListComponent implements OnInit, OnDestroy {
  @Output('OnSearch') onSearch = new EventEmitter();
  @Output('OnExport') onExport = new EventEmitter();
  @Output('OnDeleteAll') onDeleteAll = new EventEmitter();
  @Output('OnCancelAll') onCancelAll = new EventEmitter();
  @Output('OnCustomeButton') onCustomeButton = new EventEmitter();
  @Output('OnPagingChange') onPagingChange = new EventEmitter();

  @Input('IsExported') isExported: boolean = true;
  @Input('IsDeleted') isDeleted: boolean = false;
  @Input('IsDeleteEnabled') isDeleteEnabled: boolean = false;

  @Input('IsCancel') isCancel: boolean = false;
  @Input('IsCancelEnabled') isCancelEnabled: boolean = false;
  @Input('IsCustomButton') isCustomButton: boolean = false;
  @Input('IsCustomButtonEnabled') isCustomButtonEnabled: boolean = false;
  @Input('Title') title: string;
  @Input('CustomeIcon') customIcon: string;


  @Input('SearchTerm') searchTerm: string = '';
  @Input('itemPerPageList') itemPerPageList: any;
  @Input('ItemPerPage') itemPerPage: any;

  constructor() { }

  ngOnInit() {
    this.itemPerPageList = WeGoConfig.GRID_PAGGING;
    // let itemperPage = localStorage.getItem("itemsPerPage");
    // if (itemperPage) {
    //   this.itemPerPage = itemperPage
    // }
    // else {
    // this.itemPerPage = WeGoConfig.GRID_MAX_DATA_SIZE;
    // }
  }

  OnReset($event: any) {
    this.searchTerm = "";
    this.onSearch.emit({ searchTerm: this.searchTerm, isReset: true });
  }

  OnSearch() {
    this.onSearch.emit({ searchTerm: this.searchTerm, isReset: false });
  }

  OnExport($event: any) {
    this.onExport.emit($event);
  }

  OnPagingChange($event: any) {
    this.onPagingChange.emit({ itemPerPage: $event });
    // localStorage.setItem('itemsPerPage', $event);
  }

  OnDeleteAll($event: any) {
    this.onDeleteAll.emit($event);
  }

  OnCancelAll($event: any) {
    this.onCancelAll.emit($event);
  }
  OnCustomeButton($event: any) {
    this.onCustomeButton.emit($event);
  }
  ngOnDestroy() { }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/search-list.component.ts